import { Link } from 'react-router-dom';

const CHIPS = [
  { icon: 'ri-time-line',               text: 'Mon – Sat · 9am – 9pm' },
  { icon: 'ri-moon-line',               text: 'Evening Slots Until 9pm' },
  { icon: 'ri-car-line',                text: 'Mobile-Based · Fayetteville Area' },
  { icon: 'ri-money-dollar-circle-line',text: 'Pay at the Door' },
];

export default function WalkInHero() {
  const handleBook = () => {
    const btn = document.querySelector('#vapi-widget-floating-button') as HTMLElement | null;
    if (btn) btn.click();
  };

  return (
    <section className="relative min-h-[80vh] flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/47e6a875b4302433213633dc5f02d332.jpg"
          alt="Creative Institute walk-in studio"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#78350F]/92 via-[#92400E]/78 to-[#B45309]/55" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-black/20" />
      </div>

      <div className="relative z-10 w-full max-w-screen-xl mx-auto px-4 sm:px-8 pt-36 pb-24">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">

          {/* Left — text content */}
          <div className="flex-1 min-w-0">
            {/* Price badge */}
            <div
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-yellow text-brand-blue-dark font-body text-xs font-bold uppercase tracking-widest mb-7"
              style={{ animation: 'wiFadeUp 0.7s cubic-bezier(0.22,1,0.36,1) 0.1s both' }}
            >
              <i className="ri-car-line text-sm" />
              Mobile-Based · We Come to You · $30 / Hour
            </div>

            {/* Heading */}
            <h1
              className="font-heading text-white text-5xl sm:text-7xl xl:text-8xl font-black leading-tight mb-6"
              style={{ animation: 'wiFadeUp 0.7s cubic-bezier(0.22,1,0.36,1) 0.3s both' }}
            >
              Walk In.<br />
              <span className="text-brand-yellow">Play Today.</span>
            </h1>

            {/* Subtext */}
            <p
              className="font-body text-white/85 text-base sm:text-lg max-w-xl leading-relaxed mb-10"
              style={{ animation: 'wiFadeUp 0.7s cubic-bezier(0.22,1,0.36,1) 0.5s both' }}
            >
              Piano. Vocals. Drums. Call or message us, pick your instrument, and we come to you — a full hour of real instruction at your location. No enrollment, no contracts, no pressure whatsoever.
            </p>

            {/* CTAs */}
            <div
              className="flex flex-col sm:flex-row flex-wrap gap-4 mb-12"
              style={{ animation: 'wiFadeUp 0.7s cubic-bezier(0.22,1,0.36,1) 0.7s both' }}
            >
              <button
                onClick={handleBook}
                className="whitespace-nowrap inline-flex items-center gap-2.5 px-9 py-4 rounded-full bg-brand-yellow text-brand-blue-dark font-body font-bold text-base cursor-pointer hover:bg-yellow-300 transition-all"
              >
                <i className="ri-calendar-check-line text-lg" /> Book a Walk-In
              </button>
              <a
                href="tel:9102424567"
                className="whitespace-nowrap inline-flex items-center gap-2.5 px-9 py-4 rounded-full border-2 border-white/50 text-white font-body font-semibold text-base cursor-pointer hover:border-white hover:bg-white/10 transition-all"
              >
                <i className="ri-phone-line text-lg" /> 910-242-4567
              </a>
              <Link
                to="/enroll"
                className="whitespace-nowrap inline-flex items-center gap-2.5 px-9 py-4 rounded-full border-2 border-white/25 text-white/70 font-body font-semibold text-base cursor-pointer hover:border-white/60 hover:text-white transition-all"
              >
                Enroll for Regular Lessons
              </Link>
            </div>

            {/* Info chips */}
            <div
              className="flex flex-wrap gap-3"
              style={{ animation: 'wiFadeUp 0.7s cubic-bezier(0.22,1,0.36,1) 0.9s both' }}
            >
              {CHIPS.map((chip) => (
                <span
                  key={chip.text}
                  className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/15 border border-white/25 backdrop-blur-sm"
                >
                  <i className={`${chip.icon} text-brand-yellow text-sm`} />
                  <span className="font-body text-white text-xs font-medium">{chip.text}</span>
                </span>
              ))}
            </div>
          </div>

          {/* Right — stock photo card */}
          <div
            className="hidden lg:block flex-shrink-0 w-[420px] xl:w-[480px]"
            style={{ animation: 'wiFadeUp 0.8s cubic-bezier(0.22,1,0.36,1) 0.4s both' }}
          >
            <div className="relative rounded-2xl overflow-hidden w-full h-[520px] xl:h-[580px] shadow-2xl ring-4 ring-white/20">
              <img
                src="https://readdy.ai/api/search-image?query=beautiful%20grand%20piano%20in%20a%20warmly%20lit%20music%20studio%20rich%20wood%20finish%20keys%20visible%20amber%20golden%20light%20streaming%20through%20window%20elegant%20professional%20music%20school%20interior%20nobody%20present%20high%20quality%20photography&width=480&height=580&seq=walkin-hero-piano-only&orientation=portrait"
                alt="Grand piano at Creative Institute walk-in studio"
                className="w-full h-full object-cover object-top"
              />
              {/* Overlay badge */}
              <div className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-black/80 via-black/40 to-transparent">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-brand-yellow">
                    <i className="ri-music-2-line text-brand-blue-dark text-lg" />
                  </div>
                  <div>
                    <p className="font-heading text-white font-bold text-sm leading-tight">First lesson, no commitment</p>
                    <p className="font-body text-white/70 text-xs">Piano · Vocals · Drums available</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <style>{`
        @keyframes wiFadeUp {
          0%   { opacity: 0; transform: translateY(16px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
}
